<template>
  <div id="app" class="app">
     <div class="main-content" v-for="item in globalModuleList" :key="item.moduleCode">
      <!-- 导航菜单 -->
      <!-- <desktop-nav
        v-if="item.moduleCode === 'desktopNavModule' && currentLayout === 'LayoutWithoutMenu' && $route.path !== '/public/service/login'"
        :style="getModuleStyle(item)"
        :titleStyle="getTitleStyle(item)"
        :contentStyle="getContentStyle(item)"
        :module-data="item">
      </desktop-nav> -->
        <!-- <desktop-nav
            v-if="item.moduleCode === 'desktopNavModule' && shouldShowModule(item)"
            :style="getModuleStyle(item)"
            :titleStyle="getTitleStyle(item)"
            :contentStyle="getContentStyle(item)"
            :module-data="item">
        </desktop-nav> -->
        <component 
            v-if="currentLayout === 'LayoutWithoutMenu' && $route.path !== '/public/service/login'"
            :is="getComponentName(item.moduleCode)"
            :module-data="item"
            :style="getModuleStyle(item)">
        </component>
      <!-- 状态头部 -->
            <web-satus-header 
                v-if="item.moduleCode === 'headerInformation'"
                :HeaderStatusHtmlText="headerStatusHtmlText">

            </web-satus-header>
      
      <!-- 头部 -->
            <header-background 
                v-else-if="item.moduleCode === 'headerBackground'"
                :HeaderHtmlText="headerHtmlText">
            </header-background>
     </div>
    <!-- 根据当前路由的布局设置显示对应布局 -->
    <component :is="currentLayout" :key="currentLayout">
      <!-- 移除这里的 router-view，让布局组件自己处理 -->
    </component>
    <web-bottom :bottomHtmlText="bottomHtmlText" />
  </div>
</template>

<script>
const defaultLayout = 'LayoutWithoutMenu'
import LayoutWithMenu from '@/views/layouts/LayoutWithMenu.vue'
import LayoutWithoutMenu from '@/views/layouts/LayoutWithoutMenu.vue'
import { getTemplateDetail } from '@/api/common'
import { mapGetters, mapState } from "vuex";
import Cache from '@/utils/cache.js'
import headerBackground  from '@/components/WebHeader.vue'
import WebBottom from '@/components/WebBottom.vue'
import WebSatusHeader from '@/components/WebSatusHeader.vue'
import store from './store';
import { commonMixin } from "@/mixins/analysisMixin.js";
import { detailSetting } from '@/api/common'

export default {
  mixins: [commonMixin],
  data() {
    return {
      // 移除本地数据，改用 Vuex 状态
    }
  },
  components: {
    LayoutWithoutMenu,
    LayoutWithMenu,
    headerBackground,
    WebBottom,
    WebSatusHeader,
    DesktopNavModule: () => import("@/components/desktop-nav-module/desktop-nav-module.vue"),
    AutoNotificationModule: () => import("@/views/components/auto-notification-module/auto-notification-module.vue"),
    InfomationModule: () => import("@/views/components/infomation-module/infomation-module.vue"),
    ImageCarouselModule: () => import("@/views/components/image-carousel-module/image-carousel-module.vue"),
    QuickEntryModule: () => import("@/views/components/quick-entry-module/quick-entry-module.vue"),
    CooperativePartnerModule: () => import("@/views/components/cooperative-partner-module/cooperative-partner-module.vue"),
    GroupModule: () => import("@/views/components/groupModule/groupModule"),
    ThirdLinkModule: () => import("@/views/components/third-link-module/third-link-module.vue"),
    ThirdShowModule: () => import("@/views/components/third-show-module/third-show-module.vue"),
    GlobalSuspendedWindow: () => import("@/views/components/global-suspended-window/global-suspended-window.vue"),
    middleBackgroundModule: () => import("@/views/components/middle-background-module/middle-background-module.vue"),
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters('template', ['getModuleByCode']), // 从 template 模块映射 getter
    ...mapState({
      bottomHtmlText: state => state.template.bottomHtmlText,
      headerHtmlText: state => state.template.headerHtmlText,
      headerStatusHtmlText: state => state.template.headerStatusHtmlText
    }),
    currentLayout() {
      // 优先查找当前路由的 meta.layout
      let layout = this.$route.meta.layout;

      // 如果当前路由没有设置 layout，则向上查找父路由的 layout
      if (!layout) {
        const matchedRoute = this.$route.matched.find(r => r.meta && r.meta.layout);
        layout = matchedRoute ? matchedRoute.meta.layout : null;
      }

      console.log(layout, 'layoutlayout');
      return layout ? `Layout${layout.charAt(0).toUpperCase() + layout.slice(1)}` : defaultLayout
    },
    // 使用 getter 获取 desktopNavModule 模块数据
    desktopNavModule() {
      return this.getModuleByCode('desktopNavModule') || { componentList: [] };
    }
  },
  methods: {
    // 获得标签配置
    detailSetting() {
      detailSetting({cfgGroup:'WEB_SITE_TAG'}).then((res) => {
        if (res.resultData) {
          let metaList = JSON.parse(res.resultData)
          metaList.forEach(item => {
            document.head.insertAdjacentHTML('beforeend', item);
          })
        }
      })
    },
    /**
     * 获取模块样式
     */
    getModuleStyle(module) {
      try {
        let style = {}
        const moduleStyle = JSON.parse(module.moduleStyleData);

        if (moduleStyle && moduleStyle.options) {
          style = {
            ...moduleStyle.options,
          }

          // 检查是否为移动端，如果是则清除左右边距和内边距
          const isMobile = window.innerWidth <= 768;
          if (isMobile) {
            // 清除移动端的左右边距和内边距
            delete style.marginLeft;
            delete style.marginRight;
            delete style.paddingLeft;
            delete style.paddingRight;

            // 确保宽度为100%
            style.width = '100%';
            style.boxSizing = 'border-box';
          } else {
            // 桌面端保持原有逻辑
            if (style.paddingLeft || style.marginLeft) {
              style.width = 'auto';
              style.boxSizing = 'border-box';
              style.marginRight = style.marginRight || '0';
            } else if (style.width === '100%') {
              style.width = '100%';
              style.boxSizing = 'border-box';
            }
          }
        }
        style.height = "100%"
        return style;
      } catch (e) {
        console.warn(`解析模块 ${module.moduleName} 样式失败:${module}`,e );
        return {};
      }
    },
    getTitleStyle(module) { 
      try {
        let style = {}
        const moduleStyle = JSON.parse(module.moduleStyleData);
        if (moduleStyle && moduleStyle.titleStyle) {
          style = {
            ...moduleStyle.titleStyle,
          }
        }
        return style;
      } catch (e) {
        return {};
      }
    },

    getContentStyle(module) { 
      try {
        let style = {}
        const moduleStyle = JSON.parse(module.moduleStyleData);
        if (moduleStyle && moduleStyle.titleStyle) {
          style = {
            ...moduleStyle.titleStyle,
          }
        }
        return style;
      } catch (e) {
        return {};
      }
    },
        shouldShowModule(module) {
            try {
                if (!module) return false;
                const moduleStyle = module.moduleStyleData ? JSON.parse(module.moduleStyleData) : null;
                if (module.moduleCode === 'ImageCarouselModule') {
                    console.log(module, moduleStyle, 'moduleStylemoduleStylemoduleStylemoduleStyle')
                }
                if (moduleStyle && typeof moduleStyle.isFixed !== 'undefined') {
                    return !!moduleStyle.isFixed;
                }
                return module.isShow === 1 || module.isShow === true;
            } catch (e) {
                return module && (module.isShow === 1 || module.isShow === true);
            }
        },
    getTemplateDetail() {
      getTemplateDetail({id: 1}).then(res => {
        // 将数据存储到 Vuex
        this.$store.dispatch('template/setTemplateData', res);
      })
    }
  },
  mounted() {
    this.detailSetting()
    // 应用启动时检查并清除所有过期缓存
    store.dispatch('information/checkAndClearExpiredCache');

    // 定时检查并清除过期缓存（每30分钟执行一次）
    setInterval(() => {
      store.dispatch('information/checkAndClearExpiredCache');
    }, 1000 * 60 * 30);
    this.getTemplateDetail()
    if (!this.user && Cache.get('personUser')) {
      this.$store.dispatch("setUser", Cache.get('personUser'));
    }
    // 在App.vue中添加定时检查
    setInterval(() => {
      if (this.$store.state.user.token) {
        this.$store.dispatch('getMenuList') // 静默更新
      }
    }, 3600000 * 24) // 每小时检查一次
  },
}
</script>
<style lang="scss">
@import '@/assets/iconfont/iconfont.css';
</style>
<style>
body {
  margin: 0;
  padding: 0;
}
:root {
  --theme-GLOBAL_COLOR: #000; /* 默认为黑色 */
}
.app {
    position: relative;
}
.main-content {
    position: relative;
    height: 100%;
}
</style>
